const initialState = {
  sidebarShow: "responsive",
  minimize: localStorage.getItem("minimize")
    ? JSON.parse(localStorage.getItem("minimize"))
    : false,
};

export const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case "toggleSidebarShow":
      return { ...state, sidebarShow: !state.sidebarShow };
    case "toggleMinimize":
      return { ...state, minimize: !state.minimize };
    case "setSidebarShow":
      return { ...state, sidebarShow: rest.sidebarShow };
    case "setMinimize":
      return { ...state, minimize: rest.minimize };
    default:
      return state;
  }
};
